import React from 'react';
import { Col, Input, Form } from '../../../../components';

export const UserInfoFields = React.memo(() => (
    <>
        <Col span={24}>
            <Form.Item label="Username" name="username">
                <Input size="large" disabled />
            </Form.Item>
        </Col>
        <Col span={12}>
            <Form.Item label="First Name" name="first_name">
                <Input size="large" />
            </Form.Item>
        </Col>
        <Col span={12}>
            <Form.Item label="Last Name" name="last_name">
                <Input size="large" />
            </Form.Item>
        </Col>
    </>
));
